import { Divider, Form } from 'antd';
import { FormProps } from 'antd/es/form';
import { useImperativeHandle } from 'react';

import {
  CascaderTpl,
  DatePickerTpl,
  InputNumberTpl,
  InputPasswordTpl,
  InputTpl,
  RadioButtonTpl,
  RadioTpl,
  RangePickerTpl,
  SelectTpl,
  TagSelectTpl,
  TextAreaTpl,
} from './tpls/index';
import { FormType, TemplateType } from './types/tplTypes';
import { handleRangeData } from './utils';
import { BybitFormRef, QueryObjectType } from './utils/commonInterface';
import { FormConfigData } from './utils/commonInterface';

export interface BybitFormProps<FormValues, SearchValues> {
  configData: FormConfigData;
  handleSearch: (params: Partial<SearchValues>) => void;
  onFormRef?: React.MutableRefObject<BybitFormRef | undefined>;
  formType?: FormType;
  // triggerType?: TriggerType;
  initialValues?: Partial<FormValues>;
  formProps?: FormProps;
  beforeSearch?: (values: FormValues) => Partial<SearchValues>;
}
export default function BybitForm<FormValues = any, SearchValues = FormValues>({
  onFormRef,
  formType = FormType.SearchForm,
  // triggerType = TriggerType.Immediate,
  configData = { query: [] },
  initialValues = {},
  formProps = {},
  handleSearch,
  beforeSearch,
}: BybitFormProps<FormValues, SearchValues>) {
  console.log('initialValues', initialValues);
  const className =
    FormType.Form === formType ? 'bybit-form' : 'bybit-search-form';
  const formStyle = FormType.Form === formType ? { margin: 0 } : {};
  const onFinish = (values: FormValues) => {
    const params = getSearchParams(values);

    handleSearch(params);
  };
  const event =
    FormType.Form === formType ? { onFinish } : { onValuesChange: onFinish };
  const [form] = Form.useForm();

  const getSearchParams = (values: FormValues = form.getFieldsValue()) => {
    let params = handleRangeData(values);
    if (beforeSearch) {
      params = beforeSearch(params);
    }

    return params;
  };

  const getForm = () => {
    return form;
  };

  const getFormValues = () => {
    return form.getFieldsValue();
  };

  useImperativeHandle(onFormRef, () => ({
    getSearchParams,
    getForm,
    getFormValues,
  }));

  const renderFormItem = (item: QueryObjectType) => {
    if (item.tpl === TemplateType.Select) {
      return <SelectTpl key={item.id} data={item} />;
    } else if (item.tpl === TemplateType.Input) {
      return <InputTpl className={item.className} key={item.id} data={item} />;
    } else if (item.tpl === TemplateType.InputPassword) {
      return <InputPasswordTpl key={item.id} data={item} />;
    } else if (item.tpl === TemplateType.InputNumber) {
      return <InputNumberTpl key={item.id} data={item} />;
    } else if (item.tpl === TemplateType.TextArea) {
      return <TextAreaTpl key={item.id} data={item} />;
    } else if (item.tpl === TemplateType.DateRange) {
      return <RangePickerTpl key={item.id} data={item} />;
    } else if (item.tpl === TemplateType.DatePicker) {
      return <DatePickerTpl key={item.id} data={item} />;
    } else if (item.tpl === TemplateType.Cascader) {
      return <CascaderTpl key={item.id} data={item} form={form} />;
    } else if (item.tpl === TemplateType.Radio) {
      return <RadioTpl className={item.className} key={item.id} data={item} />;
    } else if (item.tpl === TemplateType.RadioButton) {
      return <RadioButtonTpl key={item.id} data={item} />;
    } else if (item.tpl === TemplateType.TagSelect) {
      return <TagSelectTpl key={item.id} data={item} />;
    } else if (item.tpl === TemplateType.Custom) {
      return (
        <Form.Item
          key={item.id}
          name={item.id}
          label={item?.label}
          {...(item.formItemProps || {})}
        >
          {item.render(item)}
        </Form.Item>
      );
    }
    return '';
  };

  return (
    <div className="bybit-container" style={formStyle}>
      <Form
        form={form}
        layout="inline"
        initialValues={initialValues || {}}
        colon={false}
        {...event}
        {...formProps}
        className={`${
          formProps.className ? formProps.className : ''
        } ${className}`}
      >
        {configData.query.map((item) => renderFormItem(item))}
        {/* 自定义额外按钮--如创建、添加button */}
        {configData.custom &&
          configData.custom.position === 'right' &&
          configData.custom.show &&
          configData.custom?.element}

        {configData.custom &&
          configData.custom.position === 'right' &&
          configData.custom.render &&
          configData.custom?.render(form)}
      </Form>
      {FormType.SearchForm === formType && (
        <Divider className="bybit-divider" />
      )}
    </div>
  );
}
